export const CREATE_WEDDING_APP_NAME = 'createwedding';
export const CREATE_WEDDING_KEY = '@@createwedding';
// Marks that a `?new=true` start-fresh intent has been consumed for the current
// browser session, so the stale draft is cleared only once on entry rather than
// on every refresh of the same URL.
export const CREATE_WEDDING_NEW_INTENT_CONSUMED_KEY = '@@createwedding:newIntentConsumed';
